import React,{useContext,useState,useEffect} from 'react'
import { Context } from '../context/contextApi';
import { useParams } from 'react-router-dom';
import { fetchDataFromAPi } from '../utils/api';
import LeftNav from './LeftNav';
import SearchResultVideo from "./SearchResultVideo"
const SearchResult = () => {
  const [result, setResult] = useState();
 
 
  const {searchQuery} = useParams();
  const {setLoading} = useContext(Context);

  useEffect(() => {
    fetchSearchResults();
  }, [searchQuery])
  
  const fetchSearchResults = () => {
    setLoading(true);
    fetchDataFromAPi(`search/?q=${searchQuery}`).then((res)=>{
      console.log(res);
      setResult(res?.contents);
      setLoading(false);
    });
  }
  return (
    <div className='flex flex-row h-[calc(100%-56px)]'>
      <LeftNav/>
        <div className="grow w-[calc(100%-240px)] h-full overflow-y-auto bg-black">
          <div className='grid grid-cols-1 gap-2 p-5'>
              {result &&  result.map((item,index) => {
                  if(item?.type !== "video") return false;
                  let video = item?.video;
                  return(
                    <SearchResultVideo
                    key={video?.videoId}
                    video={video}
                    />
                  )
              })}
          </div>
        </div>
    </div>
  )
}

export default SearchResult